import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('detalles-solicitudes-pagos'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`detalles-solicitudes-pagos/${id}`));
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`detalles-solicitudes-pagos/${id}`));
  },
  async findAllBySolicitudPagoPadreId(solicitudPagoPadreId, opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos(`detalles-solicitudes-pagos/solicitudes-pagos-padres/${solicitudPagoPadreId}`),
      {
        params: opciones.params,
      },
    );
  },
};
